var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"loading":_vm.loading,"small":"","color":"warning"},on:{"click":_vm.syncUsers}},[_vm._v(" Sync with AD ")])}
var staticRenderFns = []

export { render, staticRenderFns }